import { useEffect, useState} from 'react';
import {Outlet} from 'react-router-dom'
import {AsideDefault} from './components/aside/AsideDefault'
import {Footer} from './components/Footer'
import {HeaderWrapper} from './components/header/HeaderWrapper'
/* import {Toolbar} from './components/toolbar/Toolbar' */
import {ScrollTop} from './components/ScrollTop'
import {Content} from './components/Content'
import {PageDataProvider} from './core'
import {useLocation} from 'react-router-dom'
import {MenuComponent} from '../assets/ts/components'
import { isTokenExp } from '../../app/helpers/isTokenExp';
import store from '../../setup/redux/Store';
import { AppStyled } from './MasterLayout.styled';
import { useSelector } from 'react-redux';
import { RootState } from '../../setup';
import Announcement from '../../app/components/Announcement/Announcement';
import axios from 'axios';
import { useDispatch } from 'react-redux';
import { actionTypes } from '../../app/modules/auth/redux/PagesRedux';
const GET_ANNOUNCEMENT = '/api/v1/announcements/active'

const MasterLayout = () => {
  const dispatch = useDispatch()
  const location = useLocation()
  const state = store.getState() as any
  const expTokenLS = JSON.parse(localStorage.getItem('primus-key'))?.expToken
  const fontSize = useSelector<RootState>(({pages}) => pages.fontSize) as number
  const [showAnnouncement, setShowAnnoucement] = useState(false)
  const customerInfo = useSelector(({auth}: any) => auth.customerInfo) 
  const announcements = useSelector<RootState>(({pages}) => pages.announcements)

  useEffect(() => {
    setTimeout(() => {
      MenuComponent.reinitialization()
        axios.get(GET_ANNOUNCEMENT).then((results) => {
            if(results.data?.data?.results?.length > 0) {
              results.data.data.settings = {
                color: customerInfo.announcementColorText || '#000000',
                background: customerInfo.announcementColorBackground || '#e9edf2'
              }
              dispatch({type: actionTypes.SetAnnouncements, payload: results.data.data})
              setShowAnnoucement(true)
            }
        }).catch(error => {
            
        })
    }, 500)
  }, [])

  useEffect(() => {
    setTimeout(() => {
      MenuComponent.reinitialization()
    }, 500)
  }, [location.key])

  useEffect(() => {
    if(expTokenLS ? JSON.parse(expTokenLS) : state.expToken) {
        if (new Date() < new Date(expTokenLS ? JSON.parse(expTokenLS) : state.expToken)) {
          isTokenExp()
        }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <PageDataProvider>
      {showAnnouncement && 
        <Announcement />
      }
      <AppStyled fontSize={fontSize} className='page d-flex flex-row flex-column-fluid'>
        <AsideDefault />
        <div className='wrapper d-flex flex-column flex-row-fluid' id='kt_wrapper'>
          <HeaderWrapper />
          <div id='kt_content' className='content d-flex flex-column flex-column-fluid' style={{background: '#ECEFF4', paddingTop: announcements?.results ? 70 : 30}}>
            <div className='post d-flex flex-column-fluid' id='kt_post' style={{maxWidth: location.pathname === '/quote/grid-quotes' || location.pathname === '/trackings' || location.pathname === '/invoices' || location.pathname === '/quote/get-quote' || location.pathname === '/quote/volume-tl' || location.pathname === '/quote/drayage' || location.pathname === '/book/new-booking' ? '' : 1450}}>
              <Content>
                <Outlet />
              </Content>
            </div>
          </div>
          <Footer />
        </div>
      </AppStyled>
      <ScrollTop />
    </PageDataProvider>
  )
}

export {MasterLayout}
